import axiosInstance from './axiosInstance';

const getTransfers = (filters = {}) => {
  const { perPage, page, email } = filters;

  return axiosInstance.get('/internal/admin/transfers', {
    params: {
      per_page: perPage,
      page,
      email,
    },
  });
};

export default getTransfers;
